import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { ProfilePage } from './pages/Profile';
import { AttendancePage } from './pages/Attendance';
import { LeavePage } from './pages/Leave';
import { PayrollPage } from './pages/Payroll';
import { EmployeesPage } from './pages/Employees';
import { AssetManagementPage } from './pages/AssetManagement';
import { ReimbursementPage } from './pages/Reimbursement';
import { ReportsPage } from './pages/Reports';
import { SettingsPage } from './pages/Settings';
import { useAuth } from './context/AuthContext';

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="spinner w-10 h-10 border-4 border-primary-600 border-t-transparent" />
          <p className="text-gray-600 font-medium">Loading HRM System...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
      />

      {/* Protected routes with layout */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/attendance" element={<AttendancePage />} />
        <Route path="/leave" element={<LeavePage />} />
        <Route path="/payroll" element={<PayrollPage />} />
        
        {/* Admin routes */}
        <Route
          path="/employees"
          element={<EmployeesPage />}
        />
        <Route path="/assets" element={<AssetManagementPage />} />
        <Route path="/reimbursement" element={<ReimbursementPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      {/* Redirect root to dashboard or login */}
      <Route
        path="/"
        element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />}
      />

      {/* 404 - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
